export default __webpack_public_path__ + "static/media/istunikturnuva.cea4a4c8.webp";